import { GET_UNIT_LI, GET_UNIT_LI_COUNT, GET_UNIT_LI_PAGE, GET_UNIT_LI_PAGE_DATA } from '../constants';
import { updateObject, createReducer } from './common';

export const initialState = { 
    dlUnitCond: {}, 
    dlUnitMaxPerPage: 0, 
    dlUnitN: [], 
    dlUnitCount: 0, 
    dlUnitPage: 0    
};

const getUnitLi = (state, action) => {
    const dlUnitCond2 = ( action.payload.hasOwnProperty('dlUnitCond') ? action.payload.dlUnitCond : Object.assign({}, state.dlUnitCond) );
    const dlUnitMaxPerPage2 = ( action.payload.hasOwnProperty('dlUnitMaxPerPage') ? action.payload.dlUnitMaxPerPage : state.dlUnitMaxPerPage );
    return updateObject(state, {
        dlUnitCond: dlUnitCond2,
        dlUnitMaxPerPage: dlUnitMaxPerPage2,
        dlUnitN: [],
        dlUnitCount: 0,
        dlUnitPage: 0
    });
};

const handler = {
    [GET_UNIT_LI]: getUnitLi,
    [GET_UNIT_LI_COUNT]: (state, action) => updateObject(state, { dlUnitCount: action.payload }),
    [GET_UNIT_LI_PAGE]: (state, action) => updateObject(state, { dlUnitN: [], dlUnitPage: action.payload }),
    [GET_UNIT_LI_PAGE_DATA]: (state, action) => updateObject(state, { dlUnitN: action.payload })
}

export const dlUnitLiReducer = createReducer(initialState, handler);
